/**
 * Standard SVG attributes for stroked primitives inside ShapeVariant
 * components. Spread on every <rect>, <path>, <circle>, <polygon>,
 * <line>, or <ellipse> so the stroke width stays uniform under the
 * non-uniform aspect-ratio scaling applied by the parent SVG
 * (preserveAspectRatio="none" in Shape/Component.tsx).
 *
 * vector-effect="non-scaling-stroke" is the SVG 2 standard solution;
 * supported in all modern browsers.
 */
export const SHAPE_STROKE_PROPS = {
  vectorEffect: 'non-scaling-stroke' as const,
} as const;
